<template>
  <div>
    <HeroSection />
   <ServicesSection />
   <UserStoriesSection />
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import ServicesSection from "@/components/ServicesSection.vue";
import UserStoriesSection from "@/components/UserStoriesSection.vue";


export default {
  name: "HomePage",
  components: {
    HeroSection,
    ServicesSection,
    UserStoriesSection
  },
};
</script>
